import { Component, Injectable, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import moment from "moment";
import { ReservationService } from "src/app/layout/reservation.service";
import { GuestService } from "src/app/shared/services/guest.service";


@Injectable({
    providedIn: 'root'
})
export class ActivitiesLayoutSupportService {
    seatingTypePriceDetail = {};

    constructor(public activityService: GuestService, public route: ActivatedRoute, public rs: ReservationService){}

    getRateplanData(location, currentFromDate, matchedContinousSlots, duration, sizeMapping, restaurantId, selectedSeatingType, callbackFunction) {
        const selectedDate = moment(currentFromDate).format('YYYY-MM-DD');
        const startTime = moment(matchedContinousSlots[0]).format('HH:mm');

        let _slots = [{
            Time: moment(`${selectedDate} ${startTime}`).format('YYYY-MM-DDTHH:mm:ss'),
            DurationInMinutes: duration
        }]
        let _rateplanRequest = {
            Slots: _slots,
            Size: this.getCoverTypesize(sizeMapping),
            TableIds: location?.Id ? [
                location.Id
            ] : [],
            SeatingTypeIds: selectedSeatingType ? [selectedSeatingType] : null,
            CoverTypes: sizeMapping?.sizes,
            FinancialEffectId: null,
            BookingBehavior: 0,
            StartDate: `${selectedDate}T00:00:00.000Z`,
            EndDate: `${selectedDate}T00:00:00.000Z`,
            ActivityId:this.activityService?.selectedSpecialMeal?.Id || null
        }
        this.activityService.startLoader();
        this.rs.getLocationRateplanCalculated(restaurantId, _rateplanRequest).subscribe(data => {
            if (location) {
                location.PriceDetail = data;
            }else if(selectedSeatingType){
                this.seatingTypePriceDetail[selectedSeatingType] = data;
            }
            callbackFunction();
            this.activityService.stopLoader();
        }, err => {
            this.activityService.stopLoader();
        })
    }

    getCoverTypesize(sizeMapping): number {
        return sizeMapping?.sizes?.reduce((res, curr) => res + (+curr.Covers), 0);
    }
}